import { jsx as i } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import { convertAttributesInElement as c } from "./utils.mjs";
import { useStoryblokRichTextResolver as f } from "./richtext.mjs";
const h = s(
  ({ doc: t, resolvers: r }, o) => {
    const { render: e } = f({
      resolvers: r
    }), m = e(t), n = c(m);
    return /* @__PURE__ */ i("div", { ref: o, children: n });
  }
);
export {
  h as default
};
